<template>
  <div
    v-if="barVisible && noticeBarState.findNoticeDatas.length"
    class="render-notice-bar"
    :class="{ 'render-notice-bar--plain': config.withCard === false }"
    :style="barStyle"
  >
    <div class="render-notice-bar__main" @click="openCurrentNotice">
      <el-icon
        v-if="config.showIcon !== false"
        class="render-notice-bar__icon"
        :style="{ color: config.iconColor || config.textColor || '#ed6a0c' }"
      >
        <Bell />
      </el-icon>
      <!-- <span
        class="render-notice-bar__title"
        :style="{ color: config.textColor || '#ed6a0c' }"
      >
        {{ config.title || "消息通知" }}
      </span> -->
      <span
        class="render-notice-bar__text"
        :style="{ color: config.textColor || '#ed6a0c' }"
      >
        {{ currentNotice?.title || "" }}
      </span>
    </div>

    <div class="render-notice-bar__actions">
      <NuxtLink
        v-if="config.showMore !== false && moreLink"
        class="render-notice-bar__more"
        :to="moreLink"
        :style="{ color: config.textColor || '#ed6a0c' }"
      >
        {{ getLocaleText("查看更多") }}
      </NuxtLink>
      <button
        v-if="config.showClose !== false"
        class="render-notice-bar__close"
        type="button"
        @click.stop="hideCurrentBar"
      >
        <el-icon :style="{ color: config.textColor || '#ed6a0c' }">
          <Close />
        </el-icon>
      </button>
    </div>

    <el-dialog
      v-model="noticeBarState.noticeDataVisible"
      :width="`${config.popupWidth || 820}px`"
      append-to-body
      class="render-notice-dialog"
    >
      <template #header>
        <div class="render-notice-dialog__header">
          <span class="render-notice-dialog__title">
            {{ currentNotice?.title || "" }}
          </span>
          <button
            class="render-notice-dialog__silence"
            type="button"
            @click="closeForThreeDays"
          >
            {{ getLocaleText("3天内不再打开") }}
          </button>
        </div>
      </template>

      <div
        class="render-notice-dialog__content"
        :style="{ maxHeight: `${config.popupHeight || 560}px` }"
        v-html="currentNotice?.content || ''"
      ></div>

      <template #footer>
        <div class="render-notice-dialog__footer">
          <span class="render-notice-dialog__pager">
            {{ noticeBarState.viewNoticeIdx + 1 }}/{{ noticeBarState.findNoticeDatas.length }}
          </span>
          <el-button
            v-if="noticeBarState.viewNoticeIdx > 0"
            @click="noticeBarState.viewNoticeIdx -= 1"
          >
            {{ getLocaleText("查看上一条") }}
          </el-button>
          <el-button
            v-if="noticeBarState.viewNoticeIdx < noticeBarState.findNoticeDatas.length - 1"
            type="primary"
            @click="noticeBarState.viewNoticeIdx += 1"
          >
            {{ getLocaleText("查看下一条") }}
          </el-button>
          <el-button @click="noticeBarState.noticeDataVisible = false">
            {{ getLocaleText("关闭") }}
          </el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { computed, ref, watch } from "vue";
import { Bell, Close } from "@element-plus/icons-vue";
import { useGetNoticesList } from "~/user-center/src/components/NoticeBar/useGetNoticesList";
import {
  hideNoticeByDays,
  isNoticeHiddenByScope,
} from "~/user-center/src/components/NoticeBar/noticeUtils";
import useLocate from "./uses/useLocate.js";

const props = defineProps({
  config: {
    type: Object,
    default: () => ({}),
  },
});
const { getLocaleText } = useLocate();

const barVisible = ref(true);
const scopeKey = computed(() => `render:${props.config?.id || "notice-bar"}`);
const { getListAction, noticeBarState } = useGetNoticesList({
  isShowBar: true,
  autoPopup: props.config?.autoPopup !== false,
  pageSize: props.config?.maxCount || 50,
  storageScope: scopeKey.value,
});

const currentNotice = computed(() => {
  return noticeBarState.findNoticeDatas[noticeBarState.viewNoticeIdx] || null;
});

const moreLink = computed(() => {
  return props.config?.moreLink || "/user-center/mall/notices";
});

const barStyle = computed(() => {
  if (props.config?.withCard === false) {
    return {};
  }
  return {
    backgroundColor: props.config?.bgColor || "#fff7e6",
  };
});

watch(
  () => scopeKey.value,
  () => {
    barVisible.value = !isNoticeHiddenByScope(scopeKey.value);
  },
  { immediate: true }
);

getListAction();

function openCurrentNotice() {
  noticeBarState.noticeDataVisible = true;
}

function hideCurrentBar() {
  barVisible.value = false;
}

function closeForThreeDays() {
  hideNoticeByDays(scopeKey.value, 3);
  noticeBarState.noticeDataVisible = false;
  barVisible.value = false;
}
</script>

<style scoped lang="less">
.render-notice-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  min-height: 44px;
  padding: 10px 16px;
  border-radius: 12px;
}

.render-notice-bar--plain {
  padding: 0;
  gap: 10px;
  min-height: auto;
  border-radius: 0;
  background: transparent !important;
}

.render-notice-bar__main {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
  flex: 1;
  cursor: pointer;
}

.render-notice-bar__icon {
  font-size: 18px;
  flex: 0 0 auto;
}

.render-notice-bar__title {
  font-size: 14px;
  font-weight: 700;
  white-space: nowrap;
}

.render-notice-bar__text {
  min-width: 0;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 14px;
}

.render-notice-bar__actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 0 0 auto;
}

.render-notice-bar__more,
.render-notice-bar__close {
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  font-size: 13px;
  text-decoration: none;
}

.render-notice-dialog__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.render-notice-dialog__title {
  font-size: 18px;
  font-weight: 700;
  color: #1f2937;
}

.render-notice-dialog__silence {
  border: none;
  background: transparent;
  color: var(--el-color-primary);
  cursor: pointer;
  font-size: 13px;
}

.render-notice-dialog__content {
  overflow: auto;
  padding: 16px;
  border: 1px solid #ebeef5;
  border-radius: 8px;
}

.render-notice-dialog__footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
}

.render-notice-dialog__pager {
  margin-right: auto;
  color: #909399;
}
</style>
